import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type EmptyStateProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
  actions?: ReactNode;
};

const EmptyState = ({ title, description, icon, className, actions }: EmptyStateProps) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-neutral-700 bg-neutral-900/50 p-10 text-center",
      className
    )}
  >
    {icon && <div className="text-purple-400">{icon}</div>}
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-neutral-100">{title}</h2>
      {description && <p className="text-sm text-neutral-400">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center justify-center gap-3">{actions}</div>}
  </div>
);

export default EmptyState;
